module.exports = html2canvas;